import { initialState, NotificationState } from "./state";
import { Actions } from './actions';
import {
    NOTIFICATION_LIST, NOTIFICATION_BY_ID, NOTIFICATION_TEMPLATE_LIST, NOTIFICATION_BY_FIELD_LIST,
    ADD_NOTIFICATION_RESPONSE, UPDATE_NOTIFICATION_RESPONSE, DELETE_NOTIFICATION_RESPONSE
} from "./actionTypes";
import { SortListAscending } from "app/utils/sort.util";

export function NotificationReducer(state = initialState, action: Actions): NotificationState {
    switch (action.type) {
        case NOTIFICATION_LIST:
            return Object.assign({}, state, {
                notificationList: SortListAscending(action.payload, "name")
            });
        case NOTIFICATION_BY_FIELD_LIST:
            return Object.assign({}, state, {
                notificationByFieldList: SortListAscending(action.payload, "name")
            });
        case NOTIFICATION_BY_ID:
            return Object.assign({}, state, {
                notificationById: action.payload
            });
        case NOTIFICATION_TEMPLATE_LIST:
            return Object.assign({}, state, {
                notificationTemplateList: action.payload
            });
        case ADD_NOTIFICATION_RESPONSE:
            return Object.assign({}, state, {
                addNotificationResponse: action.payload
            });
        case UPDATE_NOTIFICATION_RESPONSE:
            return Object.assign({}, state, {
                updateNotificationResponse: action.payload
            });
        case DELETE_NOTIFICATION_RESPONSE:
            return Object.assign({}, state, {
                deleteNotificationResponse: action.payload
            });
        default:
            return state;
    }
}
